'use client';
import { ServerContext } from '@web-libs/core/server/server-context';
import { NewsSlider } from '@web-libs/features/information/features/news/ui/news-slider';
import { ContentSlide } from '@web-libs/ui/ui-components/slider/content-slider.types';
import { useEffect, useState } from 'react';
import { createInformationRepository } from '@web-libs/features/information/api/information.repository';
import { createFetchBasedHttpClient } from '@web-libs/core/http';
import { createTrmzFileDTOConverter } from '@web-libs/features/files/trmz-file/api/trmz-file-dto-converter';
import { toContentSlides } from '@web-libs/features/information/application/information-to-content-slides';

async function getNewsSlides(serverContext: ServerContext): Promise<ContentSlide[]> {
  const httpClient = createFetchBasedHttpClient({}, serverContext.tenant, serverContext.lang);
  const trmzFileConverter = createTrmzFileDTOConverter(httpClient.baseUrl, serverContext.tenant);
  const repo = createInformationRepository(httpClient, trmzFileConverter);
  const news = await repo.getPublicInformations(undefined, []);
  return await toContentSlides(news);
}

export const NewsSliderServer = (serverContext: ServerContext) => {
  const [contentSlides, setContentSlides] = useState<ContentSlide[]>([]);

  useEffect(() => {
    getNewsSlides(serverContext).then(setContentSlides);
  }, [serverContext.institution]);

  return (
    <NewsSlider contentSlides={contentSlides} />
  );
};
